<template>
    <div>
      <div class="card" id="settingDeposit">
        <div class="card-header card-header-flex" style="background-color: #368db7;">
          <div class="d-flex flex-column justify-content-center mr-auto">
            <h5><span class="mr-3" style="color: #ffffff">ตั้งค่าเวลายกเลิกรายการ เติม-ถอน</span></h5>
          </div>
        </div>
        <div class="card-body">
          <a-form :form="form" :label-col="{ span: 8 }" :wrapper-col="{ span: 12 }" @submit.prevent="handleSubmit">
            <div class="col-md-12">
              <a-form-item label="ตั้งค่าเวลายกเลิกรายการ" >
                <a-input v-model="form.transectionClose" />
              </a-form-item>
            </div>
             <a-form-item :wrapper-col="{ span: 12, offset: 8 }">
                <a-button type="primary" html-type="submit">
                    บันทึก
                </a-button>
            </a-form-item>
          </a-form>
        </div>
      </div>
    </div>
</template>
<script>
import apiClient from '@/services/api'
import Swal from 'sweetalert2'
const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})
export default {
  props: [
    'formData',
  ],
  data() {
    return {
      form: {
        transectionClose: '',
      },
    }
  },
  watch: {
    formData: function(val) {
      this.form = {
        settingID: val[0].id,
        transectionClose: val[0].transectionClose,
      }
    },
  },
  methods: {
    handleSubmit() {
      const title = 'แน่ใจหรือไม่ที่ต้องการแก้ไขตั้งค่าเวลายกเลิกรายการ เติม-ถอน'
      Swal.fire({
        icon: 'info',
        title: title,
        showCancelButton: true,
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        showLoaderOnConfirm: true,
        preConfirm: (value) => {
          if (value) {
            return apiClient.put(`setting/update/transectionClose/${this.form.settingID}`, this.form).then(response => {
              if (response.status !== 200) {
                throw new Error(response.message)
              }
              return response.data
            }).catch(error => {
              Swal.showValidationMessage(
                  `เกิดข้อผิดพลาด: ${error.message}`,
              )
            })
          }
        },
      }).then((result) => {
        if (result.isConfirmed) {
          const iconError = (result.value.code === '000') ? 'success' : 'error'
          Toast.fire({ icon: iconError, title: result.value.message })
        //   this.formData()
        }
      })
    },
  },
  async created() {
    // this.setData()
  },
}
</script>
<style>
#settingDeposit {
  background: #fff;
  /* padding: 1rem; */
  padding-top: 0;
  position: relative;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 2.5rem 5rem 0 rgba(0, 0, 0, 0.1);
  width: auto;
  height: 380px;
}

</style>
